module.exports = __webpack_public_path__ + "img/corneliusComposer.9a8266bb.png";